import { render, staticRenderFns } from "./foldingPanel.vue?vue&type=template&id=10928a62&"
import script from "./foldingPanel.vue?vue&type=script&lang=js&"
export * from "./foldingPanel.vue?vue&type=script&lang=js&"
import style0 from "./foldingPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports